import { useState } from 'react'
import { apiClient } from '../services/api'

export const useApiClient = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  // El apiClient ya maneja todos los interceptores y autenticación
  // incluyendo headers de Authorization y X-Empresa-ID

  return {
    apiClient,
    loading,
    error,
    setLoading,
    setError,
  }
}